var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-simple-table',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('tbody',_vm._l((_vm.relevantNodes),function(ref,index){
var name = ref[0];
var node = ref[1];
return _c(_vm.chooseComponent(node),{key:index,tag:"component",attrs:{"name":name,"description":name,"variables":_vm.variables,"deviceType":_vm.currentObject.assetInfo.deviceType,"node":node,"fullShvPath":_vm.fullShvPath,"types":_vm.types}})}),1)]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }